import { render, staticRenderFns } from "./alertchannels.vue?vue&type=template&id=3d2ac86b&"
import script from "./alertchannels.vue?vue&type=script&lang=js&"
export * from "./alertchannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports